//
// AlertableState.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./AlertEvaluationStrategy";
import "./AlertEvaluationIntervalUnit";

var AlertableState = createModule("BIRD::AlertableState", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        holdInterval: 4,
        evaluationStrategy: 4,
        holdIntervalUnit: 4,
        intervalUnit: 4,
        name: 7,
        clauseName: 7,
        evaluationInterval: 4,
        label: 7,
        holdIntervalStrategy: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default AlertableState;
